import { PUBLIC_URL_REGEX } from "@cohesive/ui-components";
import { publicFileUrl, type PublicCanvasFile } from "./types";

/**
 * Rewrite `https://file.{env}.cohesive.ai/public/{id}` references inside a
 * published HTML body to the canvas's own CDN copies.
 *
 * Canvas publish copies every referenced file — including the ones only
 * embedded in an HTML block's body — under `public/canvases/{id}/files/…` and
 * lists them in canvas.json `files`. The raw `/public/{id}` form resolves only
 * for records published standalone, which canvas publish deliberately does not
 * do, so an unrewritten body renders broken media for viewers. Ids missing from
 * the map are left untouched: they may be standalone-published, and inventing a
 * canvas-prefix URL for them would turn a working link into a 404.
 */
export function rewritePublicCanvasHtmlUrls(
  html: string,
  files: Record<string, PublicCanvasFile>,
  shareOrigin: string,
): string {
  if (!html) return html;
  return html.replace(PUBLIC_URL_REGEX, (original, id: string) => {
    const file = files[id];
    if (!file?.object_key) return original;
    return publicFileUrl(file, shareOrigin);
  });
}
